$(document).on("change", "#church_region_id", function() {
  var el = $("#hall_congregation_id")
  el.empty()

  $.get("/meeting_halls/congregation_select/" + $("#church_region_id").val(), function(data) {
    el.html(data).trigger("chosen:updated")
  })
})
